import { bool, number, string } from 'prop-types';
import { useUniversalNavigationContext } from '@fff-web/fff-global-nav';
import analytics, { events, trackUpgradeStarted } from '../../../../utils/analytics';
import { UPGRADE_PAGE_URL } from '../../../../utils/constants';
import env from '../../../../utils/env';
import { prependText } from '../utils/helperFuncs';
import Grouping from './grouping';
import ProductQuantity from './ProductQuantity/ProductQuantity';
import fallback from './fallback.svg';
import * as classNames from './Product.module.css';

const UPGRADE_CTA = 'Upgrade to Unlock';

const CustomizeProduct = (props) => {
  const {
    exploreDisplay,
    questionId,
    grouping,
    isSelect,
    title,
    extraChoicePrice,
    open,
    image,
    primaryQuantity,
    additionalQuantity,
    sku,
    premiumPrice,
  } = props;

  const { isNewMember } = useUniversalNavigationContext();

  const isSurpriseMe = sku === 'SURPRISE';

  //Display Containers
  const questionIdDisplay = () => (
    <div className={classNames.question}>{prependText('Customization ')(questionId)}</div>
  );

  const canEditQuestion = () =>
    open &&
    questionId &&
    (grouping !== Grouping.SELECT || (grouping === Grouping.SELECT && isSelect));

  return (
    <div className={classNames.container}>
      <div>
        <img className={classNames.thumbnail} src={image || fallback} alt={title} />
      </div>
      <div className={classNames.infoContainer}>
        <div className={classNames.info}>
          {!exploreDisplay && questionIdDisplay()}

          {/* Product Title */}
          <div className={classNames.name}>{title}</div>

          {/* Quantity & Price Display */}
          {!exploreDisplay && !isSurpriseMe && (
            <ProductQuantity
              primaryQuantity={primaryQuantity}
              additionalQuantity={additionalQuantity}
              extraChoicePrice={extraChoicePrice}
              premiumPrice={premiumPrice}
            />
          )}

          {/* Select Label Unlocked */}
          {grouping === Grouping.SELECT && (
            <div className={classNames.selectText}>
              <i className={isSelect ? classNames.unlockedIcon : classNames.lockedIcon} />
              <span>Annual Only</span>
            </div>
          )}

          {canEditQuestion() && (
            <div className={classNames.linkContainer}>
              <a
                onClick={() => {
                  analytics.track(events.CLICKED_ELEMENT, {
                    element_name: 'Edit',
                    option_title: `Customize - ${title}`,
                  });
                }}
                href={`${env.envURL}/${
                  isNewMember ? 'new-member-customize' : 'customize'
                }/?q=${questionId}`}
              >
                Edit
              </a>
            </div>
          )}

          {/* Upgrade to Unlock */}
          {!exploreDisplay && !canEditQuestion() && open && (
            <div className={classNames.linkContainer}>
              <a
                onClick={() => {
                  trackUpgradeStarted(UPGRADE_CTA);
                }}
                href={UPGRADE_PAGE_URL}
              >
                {UPGRADE_CTA}
              </a>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

CustomizeProduct.propTypes = {
  exploreDisplay: bool.isRequired,
  questionId: number.isRequired,
  grouping: string.isRequired,
  isSelect: bool.isRequired,
  title: string.isRequired,
  extraChoicePrice: number.isRequired,
  open: bool.isRequired,
  image: string.isRequired,
  primaryQuantity: number.isRequired,
  additionalQuantity: number.isRequired,
  sku: string.isRequired,
  premiumPrice: number.isRequired,
};

export default CustomizeProduct;
